export const light = {
  palette: {
    background: ['#ECEAF8', 'transparent', '#ffffff', '#f8f5fe'],
    text: ['#ffffff', '#000000'],
    gray: ['#D7D7E2', '#aba8a8'],
    border: ['#D7D7E2', '#6366f1'],
    color: ['#6366f1'],
  },

  // 4px-based spacing/sizing grid — standard for production UI systems
  sizes: {
    lineHeight: {
      xSmall: '16px',
      tiny: '20px',
      smaller: '24px',
      small: '32px',
      normal: '40px',
    },
    border: {
      tiny: '1px',
      small: '2px',
      normal: '4px',
    },
    gap: {
      tiny: '4px',
      small: '8px',
      normal: '16px',
      medium: '24px',
      big: '32px',
    },
    borderRadius: {
      tiny: '4px',
      small: '8px',
      normal: '12px',
      large: '16px',
      full: '9999px',
    },
    button: {
      small: {
        width: '120px',
        height: '36px',
      },
      // button.style.js currently reads this same 'normal' size for every
      // breakpoint tier (its xlSizes/xlrSizes/xxlSizes all point back to
      // this key) — only font-size scales per tier, button height stays
      // constant by design. Tuned to match the pill-button look in the
      // approved staging design.
      normal: {
        width: '220px',
        height: '48px',
      },
      large: {
        width: '240px',
        height: '52px',
      },
    },
    inputBox: {
      height: {
        tiny: '32px',
        xsmaller: '36px',
        smaller: '40px',
        small: '44px',
        medium: '48px',
        large: '52px',
        larger: '60px',
      },
    },
    textArea: {
      height: {
        medium: '96px',
        large: '120px',
        larger: '160px',
      },
    },

    // Base scale — used on all screens until a larger `media.*` tier below matches.
    // Consumed directly by Label/Button via styled-theme's key().
    font: {
      small: '12px',
      normal: '14px',
      medium: '16px',
      header2: '20px',
      header1: '26px',
    },
    // Reserved duplicates of the base tier for components that key off these
    // names directly (kept equal to `font` — not used by Label/Button).
    mdFont: {
      small: '12px',
      normal: '14px',
      medium: '16px',
      header2: '20px',
      header1: '26px',
    },
    lgFont: {
      small: '12px',
      normal: '14px',
      medium: '16px',
      header2: '20px',
      header1: '26px',
    },
    // Large monitors — matches Label/Button's `media.xl` tier
    xlFont: {
      small: '12px',
      normal: '14px',
      medium: '16px',
      header2: '24px',
      header1: '34px',
    },
    // `media.xlr` tier — this key was previously missing from the theme,
    // which broke Label's xlr font-size lookup. Restored here.
    xlrFont: {
      small: '13px',
      normal: '15px',
      medium: '18px',
      header2: '26px',
      header1: '40px',
    },
    // `media.xxl` tier
    xxlFont: {
      small: '14px',
      normal: '16px',
      medium: '18px',
      header2: '28px',
      header1: '48px',
    },
    // `media.vxxl` tier — largest, for ultra-wide displays
    vxxlFont: {
      small: '14px',
      normal: '18px',
      medium: '20px',
      header2: '30px',
      header1: '56px',
    },
  },

  // App breakpoints (min-width, mobile-first)
  breakpoints: {
    mobile: '480px',
    tablet: '820px',
    desktop: '1024px',
    wide: '1440px',
  },

  // Landing/marketing page breakpoints (align to common Tailwind-style scale)
  landingBreakpoints: {
    sm: '640px',
    md: '768px',
    lg: '1024px',
    xl: '1280px',
  },

  fonts: {
    primary: 'JetBrains Mono Regular',
    pre: 'Consolas, Liberation Mono, Menlo, Courier, monospace',
  },
};

export const dark = {};

export const themes = { light, dark };
